export default __webpack_public_path__ + "static/152-89e5595919e0080a1471db11d558a6ec.jpg";